import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useNotificationStore } from '../../Notification.store';
import { Notification } from '../Notification/Notification';
import { Box } from '../../../Box/Box';
import './NotificationContainer.scss';
export const NotificationContainer = ({ zIndex = 1 }) => {
    const store = useNotificationStore();
    const containers = useMemo(() => ['top-right', 'top-left', 'bottom-right', 'bottom-left'].map((placement) => ({
        className: `ds_notification-container ${placement}`,
        notifications: store.notifications.filter((notification) => notification.placement === placement),
    })), [store.notifications]);
    return (_jsx(_Fragment, { children: containers.map(({ notifications, className }, index) => (_jsx("div", { style: { zIndex }, className: className, children: _jsx(Box, { display: 'flex', flexDirection: 'column', gap: 'sm', children: notifications.map((notification) => (_jsx(Notification, { ...notification }, notification.id))) }) }, index))) }));
};
